import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import { CONTACT_ROLE_LABELS } from '../lib/format';

/** 全平台角色标签池（后端持久化，任何人填的新标签之后都可选） */
export function useRoleLabels() {
  return useQuery({
    queryKey: ['role-labels'],
    queryFn: () => api.get<{ labels: string[] }>('/role-labels').then((r) => r.labels),
    staleTime: 60_000,
  });
}

/** 内置常用项 + 平台池，去重后给 AutoComplete 用 */
export function useRoleLabelOptions(): { value: string }[] {
  const q = useRoleLabels();
  const merged = Array.from(new Set([...CONTACT_ROLE_LABELS, ...(q.data ?? [])]));
  return merged.map((v) => ({ value: v }));
}
